class PredictiveSearch extends SearchForm {
    constructor() {
        super(),
            (this.cachedResults = {}),
            (this.predictiveSearchResults = this.querySelector("[data-predictive-search]")),
            (this.allPredictiveSearchInstances = document.querySelectorAll("predictive-search")),
            (this.isOpen = !1),
            (this.abortController = new AbortController()),
            (this.searchTerm = ""),
            (this.overlay = document.querySelector(".header__overlay")),
            (this.body = document.querySelector("body")),
            (this.headerTop = document.querySelector(".header__top")),
            (this.headerBottom = document.querySelector(".header__bottom")),
            (this.promoModal = document.querySelector(".search__modal")),
            (this.headerInput = document.querySelector(".header__search .search__input")),
            this.setupEventListeners();
    }
    setupEventListeners() {
        this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
            this.input.addEventListener("focus", this.onFocus.bind(this)),
            this.addEventListener("focusout", this.onFocusOut.bind(this)),
            this.addEventListener("keyup", this.onKeyup.bind(this)),
            this.addEventListener("keydown", this.onKeydown.bind(this));
    }
    getQuery() {
        return this.input.value.trim();
    }
    onChange() {
        const e = this.getQuery();
        (this.searchTerm && e.startsWith(this.searchTerm)) || this.querySelector("#predictive-search-results-groups-wrapper")?.remove(),
            this.updateSearchForTerm(this.searchTerm, e),
            (this.searchTerm = e),
            this.searchTerm.length ? this.getSearchResults(this.searchTerm) : this.close(!0);
    }
    onFormSubmit(e) {
        (this.getQuery().length && !this.querySelector('[aria-selected="true"] a')) || e.preventDefault();
    }
    onFormReset(e) {
        super.onFormReset(e), super.shouldResetForm() && ((this.searchTerm = ""), this.abortController.abort(), (this.abortController = new AbortController()), this.closeResults(!0));
    }
    onFocus() {
        const e = this.getQuery();
        this.classList.contains("search-modal__form") &&
            (this.overlay.classList.add("visible"),
            this.headerTop.classList.add("header__top--search"),
            this.headerBottom && this.headerBottom.classList.add("header__bottom--visible"),
            this.promoModal && this.promoModal.classList.remove("search__modal--hidden")),
            e.length && (this.searchTerm !== e ? this.onChange() : "true" === this.getAttribute("results") ? (this.open(), this.promoModal && this.promoModal.classList.add("search__modal--hidden")) : this.getSearchResults(this.searchTerm));
    }
    onFocusOut() {
        this.classList.contains("search-modal__form") && (this.headerTop.classList.remove("header__top--search"), this.overlay.classList.remove("visible"), this.headerBottom && this.headerBottom.classList.remove("header__bottom--visible")),
            setTimeout(() => {
                this.contains(document.activeElement) || this.close();
            });
    }
    onBlur() {
        this.headerInput.blur();
    }
    onKeyup(e) {
        switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
            case "Enter":
                e.preventDefault(), this.selectOption();
                break;
            case "Escape":
                this.closeResults(!0), this.promoModal && this.classList.contains("search-modal__form") && this.promoModal.classList.add("search__modal--hidden");
        }
        this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
    }
    onKeydown(e) {
        ("ArrowUp" !== e.code && "ArrowDown" !== e.code) || e.preventDefault();
    }
    updateSearchForTerm(e, t) {
        const s = this.querySelector("[data-predictive-search-search-for-text]"),
            r = s?.innerText;
        if (r) {
            if (r.matchAll(new RegExp(e, "g")).length > 1) return;
            const i = r.replace(e, t);
            s.innerText = i;
        }
        this.getQuery().length ? this.hidePromoBlock() : this.showPromoBlock();
    }
    selectOption() {
        const e = this.querySelector('[aria-selected="true"] a, button[aria-selected="true"]');
        e && e.click();
    }
    getSearchResults(e) {
        const t = e.replace(" ", "-").toLowerCase();
        if ((this.setLiveRegionLoadingState(), this.cachedResults[t])) return this.renderSearchResults(this.cachedResults[t]), void this.clickSearchTabs();
        this.promoModal && this.classList.contains("search-modal__form") && this.promoModal.classList.add("search__modal--hidden");
        var s = "/search?type=product&q=" + e + "*",
            r = $(".collection-results--products");
        $.getJSON(s + "&view=json", function (e) {
            r.empty(), console.log(e), console.log(e.results);
        }),
            fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search&resources[options][fields]=title,product_type,variants.title,variants.sku,tag&resources[limit_scope]=each&resources[limit]=10&resources[type]=product`, { signal: this.abortController.signal })
                .then((e) => {
                    if (!e.ok) {
                        var t = new Error(e.status);
                        throw (this.close(), t);
                    }
                    return e.text();
                })
                .then((e) => {
                    const s = new DOMParser().parseFromString(e, "text/html").querySelector("#shopify-section-predictive-search").innerHTML;
                    this.allPredictiveSearchInstances.forEach((e) => {
                        e.cachedResults[t] = s;
                    }),
                        this.renderSearchResults(s),
                        this.clickSearchTabs(),
                        colorSwatches();
                })
                .catch((e) => {
                    if (20 !== e?.code) throw (this.close(), e);
                });
    }
    setLiveRegionLoadingState() {
        (this.statusElement = this.statusElement || this.querySelector(".predictive-search-status")),
            (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
            this.setLiveRegionText(this.loadingText),
            this.setAttribute("loading", !0);
    }
    setLiveRegionText(e) {
        this.statusElement.setAttribute("aria-hidden", "false"),
            (this.statusElement.textContent = e),
            setTimeout(() => {
                this.statusElement.setAttribute("aria-hidden", "true");
            }, 1e3);
    }
    renderSearchResults(e) {
        (this.predictiveSearchResults.innerHTML = e),
            this.setAttribute("results", !0),
            this.setLiveRegionResults(),
            this.open(),
            this.promoModal && this.classList.contains("search-modal__form") && this.promoModal.classList.add("search__modal--hidden");
    }
    clickSearchTabs() {
        const e = this.querySelectorAll(".predictive-search__results-list");
        0 != e.length &&
            (e[0].classList.add("active"),
            this.querySelector(".predictive-search__result-tab").classList.add("active"),
            this.querySelectorAll(".predictive-search__result-tab").forEach((t) => {
                t.addEventListener("click", (s) => {
                    s.preventDefault();
                    const r = t.dataset.typeTarget;
                    this.querySelectorAll(".predictive-search__result-tab").forEach((e) => {
                        e.classList.remove("active");
                    }),
                        t.classList.add("active"),
                        e.forEach((e) => {
                            e.dataset.type == r ? e.classList.add("active") : e.classList.remove("active");
                        });
                });
            }));
    }
    hidePromoBlock() {
        document.querySelector(".search__categories") && document.querySelector(".search__categories").classList.add("hide"),
            document.querySelector(".search__promo-block") && document.querySelector(".search__promo-block").classList.add("hide"),
            document.querySelector(".search__line") && document.querySelector(".search__line").classList.add("hide");
    }
    showPromoBlock() {
        document.querySelector(".search__categories") && document.querySelector(".search__categories").classList.remove("hide"),
            document.querySelector(".search__promo-block") && document.querySelector(".search__promo-block").classList.remove("hide"),
            document.querySelector(".search__line") && document.querySelector(".search__line").classList.remove("hide");
    }
    setLiveRegionResults() {
        this.removeAttribute("loading"), this.setLiveRegionText(this.querySelector("[data-predictive-search-live-region-count-value]").textContent);
    }
    open() {
        this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0), this.promoModal && this.classList.contains("search-modal__form") && this.promoModal.classList.remove("search__modal--hidden");
    }
    close(e = !1) {
        this.closeResults(e), (this.isOpen = !1);
    }
    closeResults(e = !1) {
        e && ((this.input.value = ""), this.removeAttribute("results"));
        const t = this.querySelector('[aria-selected="true"]');
        t && t.setAttribute("aria-selected", !1),
            this.input.setAttribute("aria-activedescendant", ""),
            this.removeAttribute("loading"),
            this.removeAttribute("open"),
            this.input.setAttribute("aria-expanded", !1),
            this.predictiveSearchResults.removeAttribute("style"),
            this.promoModal && this.promoModal.classList.add("search__modal--hidden");
    }
}
customElements.define("predictive-search", PredictiveSearch);
